/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './login.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/flex-layout/flexbox/api/class';
import * as i3 from '@angular/flex-layout/media-query/media-monitor';
import * as i4 from '../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i5 from '@angular/material';
import * as i6 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i7 from '@angular/forms';
import * as i8 from '../../../../app/agatextscreens/login/login.component';
import * as i9 from '@covalent/core/dialogs/services/dialog.service';
import * as i10 from '../../../../app/shared/services/authentication.service';
import * as i11 from '@angular/router';
const styles_LoginComponent:any[] = [i0.styles];
export const RenderType_LoginComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LoginComponent,data:{}});
export function View_LoginComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),86,'div',[['class',
      'login-block'],['layout','column'],['layout-fill','']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(933888,(null as any),0,i2.ClassDirective,
      [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),82,'div',[['class',
      'md-content'],['flex',''],['layout-padding','']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(933888,(null as any),0,i2.ClassDirective,
      [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),78,'div',[['class',
      'margin'],['layout-align-gt-xs','center start'],['layout-gt-xs','row']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(933888,(null as any),
      0,i2.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      74,'div',[['flex-gt-xs','50']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),71,'md-card',[['class','login-card'],['fxFlexAlign',
          'start'],['padding','']],[[2,'mat-card',(null as any)]],(null as any),(null as any),
          i4.View_MdCard_0,i4.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i5.MdPrefixRejector,
      [[2,i5.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i5.MdCard,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i6.FlexAlignDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{align:[0,'align']},(null as any)),i1.ɵdid(933888,(null as any),
          0,i2.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),0,6,'md-card-title',([] as any[]),[[2,'mat-card-title',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
          (null as any),0,i5.MdPrefixRejector,[[2,i5.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i5.MdCardTitle,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'h4',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['Login'])),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵted(0,['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),0,56,'md-card-content',([] as any[]),[[2,'mat-card-content',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i5.MdPrefixRejector,[[2,i5.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i5.MdCardContent,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          51,'form',[['class','login-form'],['novalidate','']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'submit'],
              [(null as any),'reset']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('submit' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,31).onSubmit($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,31).onReset()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.ɵbf,([] as any[]),
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i7.NgForm,[[8,
          (null as any)],[8,(null as any)]],(null as any),(null as any)),i1.ɵprd(2048,
          (null as any),i7.ControlContainer,(null as any),[i7.NgForm]),i1.ɵdid(16384,
          (null as any),0,i7.NgControlStatusGroup,[i7.ControlContainer],(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i2.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          17,'md-input-container',[['class','full-width']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,37)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i5.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i7.NgForm],[2,i7.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),
      i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),
      i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),
      i1.ɵdid(933888,(null as any),0,i2.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(1,['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,6,'input',[['mdInput',''],['name','username'],
          ['placeholder','Username'],['type','text']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],[8,
              'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',
              0]],[[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
          'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
          [(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i8.LoginComponent = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,47)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,47).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,47)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,47)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,52)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,52)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,52)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.username = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),0,i7.NgControlStatus,
          [i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[1,4]],0,i5.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i7.NgControl]],{placeholder:[0,'placeholder'],
              type:[1,'type']},(null as any)),(_l()(),i1.ɵted(1,['\n                            '])),
      (_l()(),i1.ɵted((null as any),['\n                            '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),17,'md-input-container',[['class','full-width']],
          [[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,56)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i5.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i7.NgForm],[2,i7.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,7,{_mdInputChild:0}),i1.ɵqud(335544320,8,{_placeholderChild:0}),
      i1.ɵqud(603979776,9,{_errorChildren:1}),i1.ɵqud(603979776,10,{_hintChildren:1}),
      i1.ɵqud(603979776,11,{_prefixChildren:1}),i1.ɵqud(603979776,12,{_suffixChildren:1}),
      i1.ɵdid(933888,(null as any),0,i2.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(1,['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,6,'input',[['mdInput',''],['name','password'],
          ['placeholder','Your password'],['type','password']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i8.LoginComponent = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,66)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,66).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,66)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,66)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,71)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,71)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,71)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.password = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),0,i7.NgControlStatus,
          [i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[7,4]],0,i5.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i7.NgControl]],{placeholder:[0,'placeholder'],
              type:[1,'type']},(null as any)),(_l()(),i1.ɵted(1,['\n                            '])),
      (_l()(),i1.ɵted((null as any),['\n                            '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),5,'button',[['class','bg-blue color-white mat-button'],
              ['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,
              $event) => {
            var ad:boolean = true;
            var _co:i8.LoginComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.login()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdButton_0,i4.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i5.MdPrefixRejector,[[2,i5.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i5.MdButton,
          [i1.ElementRef,i1.Renderer2,i5.Platform,i5.FocusOriginMonitor],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i5.MdButtonCssMatStyler,([] as any[]),
          (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i2.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,
          ['Login'])),(_l()(),i1.ɵted((null as any),['\n                        '])),
      (_l()(),i1.ɵted((null as any),['\n                    '])),(_l()(),i1.ɵted(0,
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i8.LoginComponent = _v.component;
    const currVal_0:any = 'login-block';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = 'md-content';
    _ck(_v,4,0,currVal_1);
    const currVal_2:any = 'margin';
    _ck(_v,7,0,currVal_2);
    const currVal_4:any = 'start';
    _ck(_v,14,0,currVal_4);
    const currVal_5:any = 'login-card';
    _ck(_v,15,0,currVal_5);
    const currVal_15:any = 'login-form';
    _ck(_v,34,0,currVal_15);
    const currVal_27:any = 'full-width';
    _ck(_v,44,0,currVal_27);
    const currVal_41:any = 'username';
    const currVal_42:any = _co.username;
    _ck(_v,49,0,currVal_41,currVal_42);
    const currVal_43:any = 'Username';
    const currVal_44:any = 'text';
    _ck(_v,52,0,currVal_43,currVal_44);
    const currVal_56:any = 'full-width';
    _ck(_v,63,0,currVal_56);
    const currVal_70:any = 'password';
    const currVal_71:any = _co.password;
    _ck(_v,68,0,currVal_70,currVal_71);
    const currVal_72:any = 'Your password';
    const currVal_73:any = 'password';
    _ck(_v,71,0,currVal_72,currVal_73);
    const currVal_75:any = 'bg-blue color-white';
    _ck(_v,78,0,currVal_75);
  },(_ck,_v) => {
    const currVal_3:any = true;
    _ck(_v,11,0,currVal_3);
    const currVal_6:any = true;
    _ck(_v,17,0,currVal_6);
    const currVal_7:any = true;
    _ck(_v,25,0,currVal_7);
    const currVal_8:any = i1.ɵnov(_v,33).ngClassUntouched;
    const currVal_9:any = i1.ɵnov(_v,33).ngClassTouched;
    const currVal_10:any = i1.ɵnov(_v,33).ngClassPristine;
    const currVal_11:any = i1.ɵnov(_v,33).ngClassDirty;
    const currVal_12:any = i1.ɵnov(_v,33).ngClassValid;
    const currVal_13:any = i1.ɵnov(_v,33).ngClassInvalid;
    const currVal_14:any = i1.ɵnov(_v,33).ngClassPending;
    _ck(_v,29,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_16:any = (null as any);
    const currVal_17:any = true;
    const currVal_18:any = i1.ɵnov(_v,37)._isErrorState();
    const currVal_19:any = i1.ɵnov(_v,37)._mdInputChild.focused;
    const currVal_20:any = i1.ɵnov(_v,37)._shouldForward('untouched');
    const currVal_21:any = i1.ɵnov(_v,37)._shouldForward('touched');
    const currVal_22:any = i1.ɵnov(_v,37)._shouldForward('pristine');
    const currVal_23:any = i1.ɵnov(_v,37)._shouldForward('dirty');
    const currVal_24:any = i1.ɵnov(_v,37)._shouldForward('valid');
    const currVal_25:any = i1.ɵnov(_v,37)._shouldForward('invalid');
    const currVal_26:any = i1.ɵnov(_v,37)._shouldForward('pending');
    _ck(_v,36,1,[currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,
        currVal_22,currVal_23,currVal_24,currVal_25,currVal_26]);
    const currVal_28:any = i1.ɵnov(_v,51).ngClassUntouched;
    const currVal_29:any = i1.ɵnov(_v,51).ngClassTouched;
    const currVal_30:any = i1.ɵnov(_v,51).ngClassPristine;
    const currVal_31:any = i1.ɵnov(_v,51).ngClassDirty;
    const currVal_32:any = i1.ɵnov(_v,51).ngClassValid;
    const currVal_33:any = i1.ɵnov(_v,51).ngClassInvalid;
    const currVal_34:any = i1.ɵnov(_v,51).ngClassPending;
    const currVal_35:any = true;
    const currVal_36:any = i1.ɵnov(_v,52).id;
    const currVal_37:any = i1.ɵnov(_v,52).placeholder;
    const currVal_38:any = i1.ɵnov(_v,52).disabled;
    const currVal_39:any = i1.ɵnov(_v,52).required;
    const currVal_40:any = (i1.ɵnov(_v,52).ariaDescribedby || (null as any));
    _ck(_v,46,1,[currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33,
        currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40]);
    const currVal_45:any = (null as any);
    const currVal_46:any = true;
    const currVal_47:any = i1.ɵnov(_v,56)._isErrorState();
    const currVal_48:any = i1.ɵnov(_v,56)._mdInputChild.focused;
    const currVal_49:any = i1.ɵnov(_v,56)._shouldForward('untouched');
    const currVal_50:any = i1.ɵnov(_v,56)._shouldForward('touched');
    const currVal_51:any = i1.ɵnov(_v,56)._shouldForward('pristine');
    const currVal_52:any = i1.ɵnov(_v,56)._shouldForward('dirty');
    const currVal_53:any = i1.ɵnov(_v,56)._shouldForward('valid');
    const currVal_54:any = i1.ɵnov(_v,56)._shouldForward('invalid');
    const currVal_55:any = i1.ɵnov(_v,56)._shouldForward('pending');
    _ck(_v,55,1,[currVal_45,currVal_46,currVal_47,currVal_48,currVal_49,currVal_50,
        currVal_51,currVal_52,currVal_53,currVal_54,currVal_55]);
    const currVal_57:any = i1.ɵnov(_v,70).ngClassUntouched;
    const currVal_58:any = i1.ɵnov(_v,70).ngClassTouched;
    const currVal_59:any = i1.ɵnov(_v,70).ngClassPristine;
    const currVal_60:any = i1.ɵnov(_v,70).ngClassDirty;
    const currVal_61:any = i1.ɵnov(_v,70).ngClassValid;
    const currVal_62:any = i1.ɵnov(_v,70).ngClassInvalid;
    const currVal_63:any = i1.ɵnov(_v,70).ngClassPending;
    const currVal_64:any = true;
    const currVal_65:any = i1.ɵnov(_v,71).id;
    const currVal_66:any = i1.ɵnov(_v,71).placeholder;
    const currVal_67:any = i1.ɵnov(_v,71).disabled;
    const currVal_68:any = i1.ɵnov(_v,71).required;
    const currVal_69:any = (i1.ɵnov(_v,71).ariaDescribedby || (null as any));
    _ck(_v,65,1,[currVal_57,currVal_58,currVal_59,currVal_60,currVal_61,currVal_62,
        currVal_63,currVal_64,currVal_65,currVal_66,currVal_67,currVal_68,currVal_69]);
    const currVal_74:any = (i1.ɵnov(_v,76).disabled || (null as any));
    _ck(_v,74,0,currVal_74);
  });
}
export function View_LoginComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-login-covalent',
      ([] as any[]),(null as any),(null as any),(null as any),View_LoginComponent_0,
      RenderType_LoginComponent)),i1.ɵdid(114688,(null as any),0,i8.LoginComponent,
      [i9.TdDialogService,i10.AuthenticationService,i11.Router],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const LoginComponentNgFactory:i1.ComponentFactory<i8.LoginComponent> = i1.ɵccf('app-login-covalent',
    i8.LoginComponent,View_LoginComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9vcmlvbi9Qcm9qZWN0cy9zaW1wbGljaXR5RW5naW5lL3ZhbG11c3QvdmFsbXVzdGZlL3NyYy9hcHAvYWdhdGV4dHNjcmVlbnMvbG9naW4vbG9naW4uY29tcG9uZW50LnRzIiwibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL2xvZ2luL2xvZ2luLmNvbXBvbmVudC50cy5Mb2dpbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgbGF5b3V0PVwiY29sdW1uXCIgbGF5b3V0LWZpbGwgY2xhc3M9XCJsb2dpbi1ibG9ja1wiPlxyXG4gICAgPGRpdiBjbGFzcz1cIm1kLWNvbnRlbnRcIiBsYXlvdXQtcGFkZGluZyBmbGV4PlxyXG4gICAgICAgIDxkaXYgbGF5b3V0LWd0LXhzPVwicm93XCIgbGF5b3V0LWFsaWduLWd0LXhzPVwiY2VudGVyIHN0YXJ0XCIgY2xhc3M9XCJtYXJnaW5cIj5cclxuICAgICAgICAgICAgPGRpdiBmbGV4LWd0LXhzPVwiNTBcIj5cclxuICAgICAgICAgICAgICAgIDxtZC1jYXJkIGNsYXNzPVwibG9naW4tY2FyZFwiIGZ4RmxleEFsaWduPVwic3RhcnRcIiBwYWRkaW5nPlxyXG4gICAgICAgICAgICAgICAgICAgIDxtZC1jYXJkLXRpdGxlPlxyXG4gICAgICAgICAgICAgICAgICAgICAgICA8aDQ+TG9naW48L2g0PlxyXG4gICAgICAgICAgICAgICAgICAgIDwvbWQtY2FyZC10aXRsZT5cclxuICAgICAgICAgICAgICAgICAgICA8bWQtY2FyZC1jb250ZW50PlxyXG4gICAgICAgICAgICAgICAgICAgICAgICA8Zm9ybSBjbGFzcz1cImxvZ2luLWZvcm1cIj5cclxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxtZC1pbnB1dC1jb250YWluZXIgY2xhc3M9XCJmdWxsLXdpZHRoXCI+XHJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGlucHV0IG1kSW5wdXQgdHlwZT1cInRleHRcIiBwbGFjZWhvbGRlcj1cIlVzZXJuYW1lXCIgWyhuZ01vZGVsKV09XCJ1c2VybmFtZVwiIG5hbWU9XCJ1c2VybmFtZVwiPlxyXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9tZC1pbnB1dC1jb250YWluZXI+XHJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8bWQtaW5wdXQtY29udGFpbmVyIGNsYXNzPVwiZnVsbC13aWR0aFwiPlxyXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxpbnB1dCBtZElucHV0IHR5cGU9XCJwYXNzd29yZFwiIHBsYWNlaG9sZGVyPVwiWW91ciBwYXNzd29yZFwiIFsobmdNb2RlbCldPVwicGFzc3dvcmRcIiBuYW1lPVwicGFzc3dvcmRcIj5cclxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvbWQtaW5wdXQtY29udGFpbmVyPlxyXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPGJ1dHRvbiBtZC1idXR0b24gKGNsaWNrKT1cImxvZ2luKClcIiBjbGFzcz1cImJnLWJsdWUgY29sb3Itd2hpdGVcIj5Mb2dpbjwvYnV0dG9uPlxyXG4gICAgICAgICAgICAgICAgICAgICAgICA8L2Zvcm0+XHJcbiAgICAgICAgICAgICAgICAgICAgPC9tZC1jYXJkLWNvbnRlbnQ+XHJcbiAgICAgICAgICAgICAgICA8L21kLWNhcmQ+XHJcbiAgICAgICAgICAgIDwvZGl2PlxyXG4gICAgICAgIDwvZGl2PlxyXG4gICAgPC9kaXY+XHJcbjwvZGl2PiIsIjxhcHAtbG9naW4tY292YWxlbnQ+PC9hcHAtbG9naW4tY292YWxlbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQSxtREFBQTtNQUFBO3NCQUFBLDZDQUFxRDtNQUFBLGFBQ2pEO01BQUE7TUFBQSxtREFBQTtNQUFBO3NCQUFBLDZDQUE0QztNQUFBLGlCQUN4QztNQUFBO01BQUEsaUVBQUE7TUFBQTtrQ0FBQSw2Q0FBeUU7YUFBQSxvQ0FDckU7TUFBQTtNQUFBLGdCQUFxQix1REFDakI7YUFBQTtVQUFBOytDQUFBLFVBQUE7TUFBQTthQUFBO2FBQUE7c0JBQUEsNENBQUE7VUFBQTtvREFBQTtVQUFBLGVBQXdELCtDQUNwRDtVQUFBO1VBQUEsaUVBQUE7VUFBQTsyQkFBQSxzQ0FBQTtVQUFBLDREQUFlO1VBQUEsaUNBQ1g7VUFBQTtVQUFBLGdCQUFJLDBDQUFVO1VBQUEsNkJBQ0Y7TUFDaEI7VUFBQTthQUFBO3VCQUFBLHNDQUFBO1VBQUEsOERBQWlCO1VBQUEsaUNBQ2I7VUFBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEsdUNBQUE7VUFBQSxvQ0FBQTtVQUFBLHNFQUFBO1VBQUEsb0VBQUE7VUFBQTtVQUFBLHNCQUFBO3NGQUFBO1VBQUEsMkNBQXlCO1VBQUEscUNBQ3JCO1VBQUE7Y0FBQTtjQUFBO2NBQUE7a0JBQUE7VUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHFFQUFBO1VBQUE7Y0FBQTthQUFBO2FBQUE7YUFBQTthQUFBO21FQUFBO1VBQUEsNkJBQXVDO01BQ25DO1VBQUE7VUFBQTtjQUFBO1VBQUE7Y0FBQTtjQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFrRDtVQUFBO1VBQUE7UUFBQTtRQUFsRDtNQUFBLHVDQUFBO1VBQUE7VUFBQSxzQkFBQTtRQUFBO01BQUEsb0NBQUE7VUFBQTtVQUFBLG9EQUFBO3VCQUFBLG1DQUFBO1VBQUEsbURBQUE7VUFBQTtjQUFBLGdDQUF5RjtNQUN4RSxtRUFDckI7VUFBQTtVQUFBO2NBQUE7Y0FBQTtrQkFBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEscUVBQUE7VUFBQTtjQUFBO2FBQUE7YUFBQTthQUFBO2FBQUE7bUVBQUE7VUFBQSw2QkFBdUM7TUFDbkM7VUFBQTtVQUFBO1VBQUE7Y0FBQTtjQUFBO2NBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQTJEO1VBQUE7VUFBQTtRQUFBO1FBQTNEO01BQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQSxvQ0FBQTtVQUFBO1VBQUEsb0RBQUE7dUJBQUEsbUNBQUE7VUFBQSxtREFBQTtVQUFBO2NBQUEsZ0NBQWtHO01BQ2pGLG1FQUNyQjtVQUFBO2NBQUE7b0JBQUE7WUFBQTtZQUFBO1lBQWtCO2NBQUE7Y0FBQTtZQUFBO1lBQWxCO1VBQUEscURBQUE7VUFBQTtVQUFBLG9DQUFBO1VBQUE7VUFBQSxzQkFBQTtVQUFBLG9DQUFBO1VBQUE7MEJBQUEsNkNBQWdFO1VBQUEsWUFBYztNQUMzRSwyREFDTztVQUFBLHlCQUNaO01BQ1IsK0NBQ0o7VUFBQSxhQUNKOztJQXRCdUI7SUFBakMsV0FBaUMsU0FBakM7SUFDUztJQUFMLFdBQUssU0FBTDtJQUM4RDtJQUExRCxXQUEwRCxTQUExRDtJQUVvQztJQUE1QixZQUE0QixTQUE1QjtJQUFTO0lBQVQsWUFBUyxTQUFUO0lBS2M7SUFBTixZQUFNLFVBQU47SUFDd0I7SUFBcEIsWUFBb0IsVUFBcEI7SUFDNkU7SUFBdkI7SUFBbEQsWUFBeUUsV0FBdkIsVUFBbEQ7SUFBMkI7SUFBWjtJQUFmLFlBQTJCLFdBQVosVUFBZjtJQUVnQjtJQUFwQixZQUFvQixVQUFwQjtJQUNzRjtJQUF2QjtJQUEzRCxZQUFrRixXQUF2QixVQUEzRDtJQUErQjtJQUFoQjtJQUFmLFlBQStCLFdBQWhCLFVBQWY7SUFFZ0M7SUFBcEMsWUFBb0MsVUFBcEM7O0lBWlo7SUFBQSxZQUFBLFNBQUE7SUFDSTtJQUFBLFlBQUEsU0FBQTtJQUdBO0lBQUEsWUFBQSxTQUFBO0lBQ0k7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxZQUFBLDBFQUFBO0lBQ0k7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLGFBQUE7UUFBQSxzREFBQTtJQUNJO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsYUFBQTtRQUFBLFdBQUEsaUVBQUE7SUFFSjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsYUFBQTtRQUFBLHNEQUFBO0lBQ0k7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxhQUFBO1FBQUEsV0FBQSxpRUFBQTtJQUVKO0lBQUEsWUFBQSxVQUFBOzs7O29CQ2hCNUI7TUFBQTsrQkFBQSxVQUFBO01BQUE7O1FBQUE7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/login/login.component.ngfactory.ts